import i18n from 'i18next';

export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const phoneRegex = /^\d{7,13}$/;
export const passWordRegex = /^.{6,}$/;
export const numberRegex = /^\d+$|^$/;
export const commaSeparatedEmailsRegex = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]+[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]+)[\W]*$/;

export const legalUrls = {
    terms: 'https://ecometri.com/terminos-y-condiciones',
    privacy: 'https://ecometri.com/politica-de-privacidad',
    contactWhatsApp:
        'https://wa.me/17543296020?text=Hola, quisiera saber más sobre Ecometri',
};

export const routes = {
    addPaymentProviders: '/config/paymentProviders/add',
    bill: '/bill',
    billing: '/config/billing',
    clientPage: '/clients',
    code: '/code',
    collectionsPage: '/collections',
    config: '/config',
    createCollection: '/create-collection',
    createOrder: '/order/create',
    createProduct: '/products/create',
    createUserRole: '/user-roles/create',
    createUserStore: '/user-stores/create',
    domain: '/config/domain',
    editOrder: '/edit',
    form: '/config/form',
    general: '/config/general',
    homeUrl: '/',
    inventoryPage: '/inventory',
    inventoryImportPage: '/inventory/import',
    importProducts: '/products/import',
    legal: '/config/legal',
    loginUrl: '/',
    ManageUserRole: '/user-roles/create',
    massiveUploadTable: '/products/import-table',
    mobileManageCategories: '/manage-categories',
    ordersPage: '/orders',
    payBill: '/pay-bill',
    paymentProviders: '/config/paymentProviders',
    payments: '/payments',
    productsTable: '/products',
    couponsPage: '/coupons',
    promotionsPage: '/promotions',
    promotionsCreate: '/promotions/create',
    promotionsCreateTier: '/promotions/create?rule=quantity_discount',
    promotionsCreateCartTier: '/promotions/cart-tier/create',
    promotionsCartTierEdit: '/promotions/cart-tier/edit',
    promotionsEdit: '/promotions/edit/:id',
    promotionsTierEdit: '/promotions/tier/edit/:id',
    qrCode: '/config/qr-code',
    recoveryPassword: '/password-recovery',
    resetPassword: '/reset',
    shipping: '/config/shipping',
    //signUpDetailsUrl: '/sign-up/details',
    signUpUrl: '/sign-up',
    signUpVerifyUrl: '/sign-up/verify',
    signUpUserInfoUrl: '/sign-up/discount',
    statsPage: '/stats',
    store: '/store',
    thankU: '/thank-you',
    updateCollection: '/edit-collection',
    updateProduct: '/products/update',
    updateUserRole: '/user-roles/update',
    updateUserStore: '/user-stores/update',
    upgradePaymentProviders: '/config/paymentProviders/update',
    uploadingProducts: '/products/uploading',
    usersRoles: '/users-roles',
    userStores: '/user-stores',
    welcomePage: '/welcome-10x',
    downloadReportPage: '/descargar-reporte-usuarios',
    editStore: '/editar-tienda',
    ecometriPlusPage: '/ecometri-plus',
}

export const errorToast = {
    variant: 'error',
    autoHideDuration: 4500
}

export const successToast = {
    variant: 'success',
    autoHideDuration: 4500
}

export const infoToast = {
    variant: 'info',
    autoHideDuration: 4500
}

export function* cartesian(head, ...tail) {
    let remainder = tail.length ? cartesian(...tail) : [[]];
    for (let r of remainder) for (let h of head) yield [h, ...r];
}

/**
 * Splits a comma separated text into trimmed chip values, skipping empty values
 * and case-insensitive duplicates (also against the already existing values)
 */
export const splitChipValues = (text, existingValues = []) => {
    const seen = existingValues.map(value => value.toLowerCase());
    return text.split(',').map(value => value.trim()).filter(value => {
        if (!value || seen.includes(value.toLowerCase())) return false;
        seen.push(value.toLowerCase());
        return true;
    });
}

/**
 * Mobile keyboards don't report the comma key on keydown, so ChipInput's newChipKeys never fire there.
 * Splits the typed text at its last comma: the complete values before it and the text still being typed.
 */
export const splitTypedChips = (text) => {
    const lastComma = text.lastIndexOf(',');
    return {
        completed: text.slice(0, lastComma),
        rest: text.slice(lastComma + 1).trimStart()
    };
}


const langDictionary = {
    es: 'es-CO',
    br: 'pt-BR'
}

const options = {
    dateStyle: 'long'
}

export const formatDate = value => {
    return new Intl.DateTimeFormat(langDictionary[i18n.language]).format(new Date(value));
}

export const formatDateLarge = value => {
    return new Intl.DateTimeFormat(langDictionary[i18n.language], options).format(new Date(value));
}

// Fixed format number function
export const formatNumber = (value, currency = false, toParts = false) => {
    // Handle null, undefined, or invalid values
    if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
        value = 0;
    }

    // Ensure value is a number
    const numericValue = Number(value);

    const formatter = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: currency || 'COP'
    });

    if (toParts) return formatter.formatToParts(numericValue);
    if (!currency || currency === 'COP') {
        return formatter.format(numericValue).replace(',00', '');
    }

    console.log('Original value:', value);
    console.log('Numeric value:', numericValue);
    console.log('Formatted result:', formatter.format(numericValue));

    return formatter.format(numericValue);
};

export const currencyToString = (currency) => {
    return new Intl.NumberFormat(langDictionary[i18n.language], {
        style: 'currency',
        currencyDisplay: 'name',
        currency
    }).format().replace('NaN', '').trim()
};


export const copyText = (text, messageSuccess) => {
    document.addEventListener('copy', (e) => {
        e.clipboardData.setData('text/plain', (text));
        e.preventDefault();
        document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
};